import cx from 'classnames'
import { type KeenSliderInstance } from 'keen-slider'

interface GalleryCarouselArrowRightProps {
  slider: KeenSliderInstance | null
  label: string
  id?: string
  cornerControls?: boolean
}

const GalleryCarouselArrowRight = ({
  label,
  slider,
  cornerControls,
}: GalleryCarouselArrowRightProps) => {
  return (
    <button
      onClick={() => slider?.next()}
      aria-label={label}
      className={cx(
        'w-8 h-8 p-2 rounded-full',
        'bg-transparent transition-colors duration-300 hover:bg-pageBG hover:bg-opacity-20',
        {
          'absolute bottom-3 right-3': cornerControls,
        },
      )}
    >
      {/* <Icon
        name="ArrowRight" // TODO: Missing icon. Not found in design.
        id={`next-${id}`}
        className="block"
      /> */}
    </button>
  )
}

export default GalleryCarouselArrowRight
